module.exports = __webpack_public_path__ + "094dce2bcaf4939b4334ae2a963143.svg";